var map = {
	"./contact/EditComponent": 866,
	"./cpo/EditComponent": 867,
	"./customer/EditComponent": 868,
	"./forwarderPo/EditComponent": 869,
	"./incomingInvoice/EditComponent": 870,
	"./incomingPayment/EditComponent": 871,
	"./outgoingInvoice/EditComponent": 872,
	"./outgoingPayment/EditComponent": 873,
	"./outgoingQuote/EditComponent": 874,
	"./product/EditComponent": 875,
	"./receiving/EditComponent": 876,
	"./shipping/EditComponent": 877,
	"./spo/EditComponent": 878,
	"./spoSched/EditComponent": 879,
	"./vatDeductRecord/EditComponent": 880,
	"./vendor/EditComponent": 881
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 865;